import { defineType, defineField } from 'sanity';
import { HiOutlinePhotograph } from 'react-icons/hi';

export default defineType({
	name:   'galleryPage',
	title:  'Gallery Page',
	type:   'document',
	icon:   HiOutlinePhotograph,
	fields: [
		defineField({
			name:       'title',
			title:      'Page Title',
			type:       'localizedText',
			validation: Rule => Rule.required(),
		}),
		defineField({
			name:  'gallery',
			title: 'Gallery Images',
			type:  'array',
			of:    [ { type: 'galleryItem' } ],
		}),
		defineField({
			name:   'sustainableMove',
			title:  'Sustainable Move',
			type:   'object',
			fields: [
				defineField({
					name:       'title',
					title:      'Title',
					type:       'localizedText',
					validation: Rule => Rule.required(),
				}),
				defineField({
					name:       'description',
					title:      'Description',
					type:       'localizedBlockContent',
					validation: Rule => Rule.required(),
				}),
			],
		}),
	],
	preview: { prepare: () => ({ title: 'Gallery Page' }) },
});